import { GroundingSourceText } from '@rp/contracts'
import { useMutation } from '@tanstack/react-query'
import { useReadySession } from '../../session/useSession'

export const useSourceText = (itemId: string, onAdopt: (text: string) => void) => {
  const { api } = useReadySession()
  return useMutation({
    mutationFn: async (sourceId: string) =>
      (
        await api.request(GroundingSourceText, {
          method: 'GET',
          path: `/v1/queue/${itemId}/suggest/sources/${sourceId}`,
        })
      ).data,
    onSuccess: (source) => onAdopt(source.text),
  })
}
